// ============================================================
// Root Layout — provides Auth, Permission, School, and Public School contexts
// ============================================================
// This component sits at the root of the router tree so that
// all route components can consume these contexts.

import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { AuthProvider } from '@/auth/AuthContext';
import { PermissionProvider } from '@/auth/PermissionContext';
import { SchoolProvider } from '@/auth/SchoolContext';
import { PublicSchoolProvider } from '@/context/PublicSchoolContext';
import { SessionTimeoutModal } from '@/components/common/SessionTimeoutModal';
import { Loader } from '@/components/feedback/Loader';

export function RootLayout() {
  return (
    <PublicSchoolProvider>
      <AuthProvider>
        <PermissionProvider>
          <SchoolProvider>
            <Suspense fallback={<Loader fullScreen message="Loading application..." />}>
              <Outlet />
            </Suspense>
            <SessionTimeoutModal />
          </SchoolProvider>
        </PermissionProvider>
      </AuthProvider>
    </PublicSchoolProvider>
  );
}

